var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 23.76 120 47.52 120 72 C80.4 72 40.8 72 0 72 C0 48.24 0 24.48 0 0 Z ",
    fill: "#DD0000",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 7.92 120 15.84 120 24 C80.4 24 40.8 24 0 24 C0 16.08 0 8.16 0 0 Z ",
    fill: "#FFCE00",
    transform: "translate(0,48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 7.92 120 15.84 120 24 C80.4 24 40.8 24 0 24 C0 16.08 0 8.16 0 0 Z ",
    fill: "#000000",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.51c437e04cf45bb8d1c58de1bde628cb.svg";
export { ForwardRef as ReactComponent };